import mockData from "../../data/mock.json";
import isoCodes from "../../data/iso-codes.json";
const state = () => ({
  filters: mockData,
  isoCodes,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  async updateEnabledFilters({ commit, state }, { url, data }) {
    // TODO to be implemented
  },
};

const actions = {
  async getData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
  async getElasticResults({ commit, state }, { url, data }) {
    const body = {
      method: "POST",
      url: `${this.$config.ecsApiURL}/${this.$config.ecsTaxIndex}${url}`,
    };

    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
  async getEnabledFilters({ commit, state }, { url, data }) {
    // TODO to be implemented
  },

  async clearEnabledFilters({ commit, state }, { url, data }) {
    // TODO to be implemented
  },
  async saveFilterToWatchlist({ commit, state }, data) {
    const body = {
      method: "POST",
      url: `${this.$config.apiURL}/watchlist`,
      data,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
